import { ApiFunctionType, httpGet, httpGetCancellable } from 'src/utils/http';

const path = '/releasetoggle';

/** release feature flags */
export const apiGetReleaseToggleEnabled = (flagName: string): Promise<boolean> =>
  httpGet(`${path}/isreleasetoggleenabled`, {
    toggleName: flagName,
  });

export const apiGetReleaseToggleEnabledCancellable: ApiFunctionType<{ toggleName: string }, boolean> =
  httpGetCancellable(`${path}/isreleasetoggleenabled`);
